import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_POLLS } from "./graphql";
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import { LinkButton } from "../../components/LinkButton";
import { PageContainer } from "../../components/PageContainer";
import { LoadingOverlay } from "../../components/Loading";
import { useParams } from "react-router-dom";
import { GET_POLL, GET_POLL_RESULT } from "../post/graphql";
import { Poll, PollResults } from "../../__generated__/graphql";
import dayjs from "dayjs";

const PollResultsPage = () => {
  const { id } = useParams();

  const [getResult, { data: resultData, loading: resultLoading }] =
    useLazyQuery(GET_POLL_RESULT);
  const [getPoll, { data, loading }] = useLazyQuery(GET_POLL);

  useEffect(() => {
    if (!id) return;

    getPoll({ variables: { id: id } });
    getResult({ variables: { id: id } });
  }, [id]);

  if (loading || resultLoading || !resultData?.pollResults || !data?.poll)
    return null;

  // @ts-ignore
  return <PollChart result={resultData?.pollResults} poll={data?.poll} />;
};

export const PollChart = ({
  result,
  poll,
}: {
  result: PollResults;
  poll: Poll;
}) => {
  const sorted = [...result.results].sort((a, b) => b.count - a.count);

  console.log('result', sorted)
  return (
    <PageContainer title={`${poll.title} - Results`}>
      <h3>
        Expiry Date and time {dayjs(poll.expiryDate).format("YYYY/MM/DD HH:mm")}
      </h3>
      <h3>
        Total User Responses {result.totalResponses}
      </h3>
      <LoadingOverlay loading={false}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Option</TableCell>
                <TableCell align="left">Votes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sorted.map((row) => (
                <TableRow
                  key={row.option}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left">{row.option}</TableCell>
                  <TableCell align="left">{row.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </LoadingOverlay>
    </PageContainer>
  );
};

export default PollResultsPage;
